import { Tooltip } from '@material-ui/core';

import { RiChat1Line } from '@remixicon/react';

import {
  useCommentState,
  useCommentZone,
  useOpenCommentsForZone,
} from '@spotify/plugin-confidence-comments-react';

import { ToolbarButton } from '../ToolbarButton';

export const BlockCommentButton = () => {
  const zone = useCommentZone();
  const comment = useCommentState(state => state.comment);
  const selectComment = useCommentState(state => state.selectComment);
  const comments = useOpenCommentsForZone(zone);
  const commentCount = comments.length;

  const handleClick = () => {
    if (commentCount > 0) {
      selectComment(comments[0].name, { zone });
    } else {
      comment({ zone });
    }
  };

  const tooltipLabel =
    commentCount > 0
      ? `${commentCount} comment${commentCount > 1 ? 's' : ''}`
      : 'Add comment';

  return (
    <Tooltip title={tooltipLabel}>
      <ToolbarButton
        active={commentCount > 0}
        aria-label={commentCount > 0 ? 'View comments' : 'Add comment'}
        onClick={handleClick}
        data-track-id={
          commentCount > 0 ? 'button.view-comments' : 'button.add-comment'
        }
        data-track-action={commentCount > 0 ? 'navigate' : 'create'}
       data-track-source-anchor="a990b305b3">
        <RiChat1Line />
      </ToolbarButton>
    </Tooltip>
  );
};
